import mixpanel from "mixpanel-browser";
import posthog from "posthog-js";

// mixpanel.init() only runs once analytics consent is granted
// (AuthenticationAndAnalytics.js), so mixpanel.track() before that reads
// internal state init() never set up and throws. Guard on the public
// __loaded flag so untracked events no-op instead of crashing the caller.
export function trackEvent(name, properties) {
  if (!mixpanel.__loaded) return;
  // Analytics is never worth failing a user action for. Callers put these on hot
  // paths — mid-send, inside upload try/catch blocks — where a throw would abort
  // the thing being measured.
  try {
    mixpanel.track(name, properties);
  } catch (e) {
    console.warn("trackEvent failed:", name, e);
  }
}

// posthog.capture() itself won't throw pre-init (it checks __loaded and
// just logs a console warning), but that warning is noise on every call
// for every unconsented user. Same guard, for a quiet no-op instead —
// consent/opt-out after init is still enforced internally by capture().
export function captureEvent(name, properties) {
  if (!posthog.__loaded) return;
  try {
    posthog.capture(name, properties);
  } catch (e) {
    console.warn("captureEvent failed:", name, e);
  }
}

// Persistent per-user flag via PostHog's own storage (a "super property",
// not an event) — set once, then readable back synchronously on later page
// loads to gate UI, e.g. "has this user already finished onboarding".
// Same __loaded guard as captureEvent, so it's a quiet no-op before consent
// instead of throwing/warning.
export function setPersistedFlag(name, value) {
  if (!posthog.__loaded) return;
  try {
    posthog.register({ [name]: value });
  } catch (e) {
    console.warn("setPersistedFlag failed:", name, e);
  }
}

export function getPersistedFlag(name) {
  if (!posthog.__loaded) return undefined;
  return posthog.get_property(name);
}
